import React from 'react';

import { BuilderBlocks } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import BuilderLocalizedText from '~/shared/components/BuilderLocalizedText';
import {
  FABLETICS_BUILDER_ENUMS,
  ListColumn,
} from '~/techstyle-shared/react-builder-models';
import { Separator } from '~/techstyle-shared/react-components';

const NAV_CONTENT_COLORS = FABLETICS_BUILDER_ENUMS.NAV_CONTENT_COLORS;
const LIST_COLUMN_CONTAINERS = ListColumn.LIST_COLUMN_CONTAINERS;

const separatorStyle = css`
  margin: 0;
`;

const ruleStyle = css`
  margin: 0;

  ${({ theme }) => theme.listColumn.separator}
`;

const ColumnHeader = styled.p`
  ${({ theme }) => theme.listColumn.header}

  ${({ $customHeaderColor, theme }) =>
    $customHeaderColor &&
    $customHeaderColor !== NAV_CONTENT_COLORS.DEFAULT &&
    theme.builderHeader.customColors[$customHeaderColor]};
`;

const Wrapper = styled.div`
  padding-bottom: 6px;
  ${({ $container, theme }) =>
    $container === LIST_COLUMN_CONTAINERS.FOOTER &&
    theme.listColumn.wrapper.footer}
`;

const StyledUnorderedList = styled.ul`
  ${({ $container, theme }) =>
    $container === LIST_COLUMN_CONTAINERS.FOOTER &&
    theme.listColumn.unorderedList.footer}
`;

function BuilderListColumn({
  builderBlock: { id, children },
  hasColumnHeader,
  columnHeader,
  columnHeaderColor,
  columnContainer,
}) {
  return (
    <Wrapper
      $container={columnContainer}
      data-builder-component-type="list_column"
    >
      {hasColumnHeader && (
        <>
          <ColumnHeader $customHeaderColor={columnHeaderColor}>
            <BuilderLocalizedText text={columnHeader} />
          </ColumnHeader>

          <Separator ruleStyle={ruleStyle} separatorStyle={separatorStyle} />
        </>
      )}

      <StyledUnorderedList $container={columnContainer}>
        <BuilderBlocks parentElementId={id} blocks={children} />
      </StyledUnorderedList>
    </Wrapper>
  );
}

BuilderListColumn.propTypes = {
  builderBlock: PropTypes.shape({
    id: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }),
  columnContainer: PropTypes.string,
  columnHeader: PropTypes.string,
  columnHeaderColor: PropTypes.string,
  hasColumnHeader: PropTypes.bool,
};

export default BuilderListColumn;
